export default __webpack_public_path__ + "static/glacial-86c62f7782e1197f70bc5c32013e5cec.jpg";